import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bb63bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"width":"500px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "（如：固定桥修复，骨粘连的牙齿，种植体修复等）", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#fff"} }, "1", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"30px"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "维持"),
  /*#__PURE__*/_createElementVNode("div", null, "仅改善尖牙关系"),
  /*#__PURE__*/_createElementVNode("div", null, "改善尖牙和磨牙关系（请在特殊说明中详细描述）"),
  /*#__PURE__*/_createElementVNode("div", null, "纠正到Ⅰ类关系（尖牙和磨牙）")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "R", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "L", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "牙齿移动方法选择（如果选择多于一个选项，请在特殊说明中说明调整量和顺序）", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "pl20" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "精密切割（可能对矫治器的强度和耐久性有一定影响,隐形矫正需要填写）", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "pl20" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "精密切割（可能对矫治器的强度和耐久性有一定影响,隐形矫正需要填写）", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "纠正开合", -1))
const _hoisted_16 = { class: "pl20" }
const _hoisted_17 = { class: "pl20" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "纠正深覆合", -1))
const _hoisted_20 = { class: "pl20" }
const _hoisted_21 = { class: "pl20" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "pl20" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "pl20" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "pl20" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "间隙", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "拥挤", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上颌", -1))
const _hoisted_31 = { class: "pl20" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "扩弓", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "唇倾", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IPR，前牙", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IPR，右上", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IPR，左上", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下颌", -1))
const _hoisted_38 = { class: "pl20" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "扩弓", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "唇倾", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IPR，前牙", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IPR，右上", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IPR，左上", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "拔牙", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "首次治疗将会应用以上选项。", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "若需配合支抗钉或其他辅助治疗，请在特殊说明中指出。", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "（注：若选择“是”，在初次设计时将会合并所有临床操作至第一步）", -1))

import { onMounted } from "vue";
import tooth from "@/components/view/tooth.vue";
import { message } from "ant-design-vue";
import {
  option,
  onChange,
  onCode2Change
} from "./Prescription/Prescription"; // 处方数据和切换操作

import {
  plainOptions,
  radioStyle,
  data
} from "./Prescription/data"; // 其他数据


export default /*#__PURE__*/_defineComponent({
  __name: 't29',
  props: {
  query: {
    type: Object,
    default: () => {
      return {
        isStealth: 1,
        taskInfo: {}
      }
    }
  },
  prescription: {
    type: String,
    default: ''
  }
},
  emits: ['selectChange'],
  setup(__props, { expose, emit: emits }) {

const props = __props;


// import { finishTask } from "@/api/home";


const onSubmit = () => {
  if (option.value[0].data.length < 1) {
    message.error('请填写临床诊断信息')
    return
  }
  console.log("提交", JSON.stringify(option.value));
  let res = {
    info: JSON.stringify(option.value),
    type: 3
  }
  emits('selectChange', res);
};
const onSaveData = () => {
  console.log("提交", JSON.stringify(option.value));
  let res = {
    info: JSON.stringify(option.value),
    type: 3
  }
  emits('selectChange', res);
};

expose({
  onSubmit,
  onSaveData
});

onMounted(() => {
    if (props.prescription) {
      option.value = JSON.parse(props.prescription)
      console.log(option.value);
      data.disabled = true
      data.loading = true;
    } else {
      console.log('11111', props.query.taskInfo.variables.prescription);

      if (props.query.taskInfo.variables.prescription) {
        // option.value = []
        option.value = JSON.parse(props.query.taskInfo.variables.prescription)
        console.log(option.value);
      }
      data.loading = true;
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(data).loading)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          layout: "vertical",
          model: _unref(option)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "1、临床治疗情况",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_checkbox_group, {
                    value: _unref(option)[0].data,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(option)[0].data) = $event)),
                    disabled: _unref(data).disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plainOptions), (item) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              key: item.value,
                              span: 6
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  value: item.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"]),
                  _createVNode(_component_a_input, {
                    value: _unref(option)[0].comment,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(option)[0].comment) = $event)),
                    placeholder: "如有补充说明或其他情况,请填写",
                    disabled: _unref(data).disabled
                  }, null, 8, ["value", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "2、需要治疗的牙弓" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox_group, {
                  value: _unref(option)[1].data,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(option)[1].data) = $event)),
                  style: {"width":"100%"},
                  onChange: _cache[5] || (_cache[5] = ((value) => _unref(onCode2Change)(1, value))),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_checkbox, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("上颌")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_group, {
                        value: _unref(option)[1].children[0].data,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(option)[1].children[0].data) = $event)),
                        disabled: !_unref(option)[1].data.includes(0)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("无需调整")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("以模型来判断")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_checkbox, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("下颌")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_group, {
                        value: _unref(option)[1].children[1].data,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(option)[1].children[1].data) = $event)),
                        disabled: !_unref(option)[1].data.includes(1)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("无需调整")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("以模型来判断")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "3、需要治疗的牙齿" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[2].data,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(option)[2].data) = $event)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("所有牙齿")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("仅前牙")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "4、牙齿移动限制" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[3].data,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(option)[3].data) = $event)),
                  onChange: _cache[9] || (_cache[9] = (value) => _unref(onCode2Change)(3, value)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      value: 0,
                      style: _normalizeStyle(_unref(radioStyle))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("无（可以移动所有牙齿）")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      value: 1,
                      style: _normalizeStyle(_unref(radioStyle))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("以下牙齿不可移动")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createElementVNode("div", null, [
                      _createVNode(tooth, {
                        onOnChange: _cache[7] || (_cache[7] = (checked) => _unref(onChange)(checked, 3)),
                        disabled: _unref(data).disabled || _unref(option)[3].data != 1,
                        tooth: _unref(option)[3].children
                      }, null, 8, ["disabled", "tooth"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "5、新的附件设计要求（隐形矫正需要填写）" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[4].data,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(option)[4].data) = $event)),
                  onChange: _cache[12] || (_cache[12] = (value) => _unref(onCode2Change)(4, value)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("根据需要设计附件")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("以下牙齿不要设计附件")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createElementVNode("div", null, [
                      _createVNode(tooth, {
                        onOnChange: _cache[10] || (_cache[10] = (checked) => _unref(onChange)(checked, 4)),
                        disabled: _unref(data).disabled || _unref(option)[4].data != 1,
                        tooth: _unref(option)[4].children
                      }, null, 8, ["disabled", "tooth"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "6、矢状向（A-P）关系" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createVNode(_component_a_radio_group, {
                          value: _unref(option)[5].children[0].data,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(option)[5].children[0].data) = $event)),
                          disabled: _unref(data).disabled
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 1
                            }, null, 8, ["style"]),
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 2
                            }, null, 8, ["style"]),
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 3
                            }, null, 8, ["style"]),
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 4
                            }, null, 8, ["style"])
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_component_a_radio_group, {
                          value: _unref(option)[5].children[1].data,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(option)[5].children[1].data) = $event)),
                          disabled: _unref(data).disabled
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 1
                            }, null, 8, ["style"]),
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 2
                            }, null, 8, ["style"]),
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 3
                            }, null, 8, ["style"]),
                            _createVNode(_component_a_radio, {
                              style: _normalizeStyle(_unref(radioStyle)),
                              value: 4
                            }, null, 8, ["style"])
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_8,
                _createVNode(_component_a_checkbox_group, {
                  value: _unref(option)[5].children[2].data,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(option)[5].children[2].data) = $event)),
                  style: {"width":"100%"},
                  onChange: _cache[18] || (_cache[18] = ((value) => _unref(onCode2Change)(5, value))),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("后牙片切")
                      ]),
                      _: 1
                    }),
                    _hoisted_9,
                    _createVNode(_component_a_checkbox, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ⅱ/Ⅲ类牵引（需要牵引）")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_a_radio_group, {
                        value: _unref(option)[5].children[2].children[0].data,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(option)[5].children[2].children[0].data) = $event)),
                        disabled: _unref(data).disabled || !_unref(option)[5].children[2].data.includes(1)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("是")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("否")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ]),
                    _hoisted_12,
                    _createVNode(_component_a_checkbox, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("远移磨牙")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_a_radio_group, {
                        value: _unref(option)[5].children[2].children[1].data,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(option)[5].children[2].children[1].data) = $event)),
                        disabled: !_unref(option)[5].children[2].data.includes(2)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("是")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("否")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "7、覆盖" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[6].data,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(option)[6].data) = $event)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("动画方案出来后再确定")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("维持初始状态 (可能需要片切)")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("通过片切来改善")
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "8、覆合",
              disabled: _unref(data).disabled
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[7].data,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(option)[7].data) = $event)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("排齐之后看结果再确定")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("维持初始状态 (可能需要片切)")
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"]),
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createVNode(_component_a_radio_group, {
                    value: _unref(option)[7].children[0].data,
                    "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_unref(option)[7].children[0].data) = $event)),
                    onChange: _cache[24] || (_cache[24] = ((value) => _unref(onCode2Change)(7, value, 0))),
                    disabled: _unref(data).disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("前牙内收")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_checkbox_group, {
                          value: _unref(option)[7].children[0].children[0].data,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_unref(option)[7].children[0].children[0].data) = $event)),
                          disabled: _unref(data).disabled || _unref(option)[7].children[0].data != 0
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, { value: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("上颌")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_checkbox, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("下颌")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("前牙内收、磨牙压低")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_checkbox_group, {
                          value: _unref(option)[7].children[0].children[1].data,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_unref(option)[7].children[0].children[1].data) = $event)),
                          disabled: _unref(data).disabled || _unref(option)[7].children[0].data != 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, { value: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("上颌")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_checkbox, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("下颌")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_a_checkbox, {
                      checked: _unref(option)[7].children[0].comment,
                      "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_unref(option)[7].children[0].comment) = $event)),
                      disabled: _unref(data).disabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("其他（需要配合支抗钉纠正）")
                      ]),
                      _: 1
                    }, 8, ["checked", "disabled"])
                  ])
                ]),
                _hoisted_18,
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _createVNode(_component_a_radio_group, {
                    value: _unref(option)[7].children[1].data,
                    "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_unref(option)[7].children[1].data) = $event)),
                    onChange: _cache[29] || (_cache[29] = ((value) => _unref(onCode2Change)(7, value, 1))),
                    disabled: _unref(data).disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("前牙压低")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_checkbox_group, {
                          value: _unref(option)[7].children[1].children[0].data,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_unref(option)[7].children[1].children[0].data) = $event)),
                          disabled: _unref(data).disabled || _unref(option)[7].children[1].data != 0
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, { value: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("上颌")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_checkbox, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("下颌")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("前牙压低、磨牙伸长")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_checkbox_group, {
                          value: _unref(option)[7].children[1].children[1].data,
                          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_unref(option)[7].children[1].children[1].data) = $event)),
                          disabled: _unref(data).disabled || _unref(option)[7].children[1].data != 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, { value: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("上颌")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_checkbox, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("下颌")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_a_checkbox, {
                      checked: _unref(option)[7].children[1].comment,
                      "onUpdate:checked": _cache[30] || (_cache[30] = ($event: any) => ((_unref(option)[7].children[1].comment) = $event)),
                      disabled: _unref(data).disabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("其他（需要配合牵引）")
                      ]),
                      _: 1
                    }, 8, ["checked", "disabled"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_a_form_item, { label: "9、中线" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[8].data,
                  "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_unref(option)[8].data) = $event)),
                  onChange: _cache[32] || (_cache[32] = (value) => _unref(onCode2Change)(8, value, 1)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("动画方案出来后再确定")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("维持初始状态 (可能需要片切)")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("通过片切来改善")
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"]),
                _createVNode(_component_a_checkbox_group, {
                  value: _unref(option)[8].children[0].data,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_unref(option)[8].children[0].data) = $event)),
                  disabled: _unref(data).disabled || _unref(option)[8].data != 2,
                  style: {"width":"100%"},
                  class: "pl20"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("上颌")
                      ]),
                      _: 1
                    }),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_a_radio_group, {
                        value: _unref(option)[8].children[0].children[0].data,
                        "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_unref(option)[8].children[0].children[0].data) = $event)),
                        disabled: _unref(data).disabled || !_unref(option)[8].children[0].data.includes(1),
                        onChange: _cache[36] || (_cache[36] = (value) => _unref(onCode2Change)(8, value, 2))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("向患者右侧移动 "),
                              _createVNode(_component_a_input, {
                                style: {"width":"80px"},
                                value: _unref(option)[8].children[0].children[0].children[0].comment,
                                "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_unref(option)[8].children[0].children[0].children[0].comment) = $event)),
                                disabled: _unref(data).disabled || _unref(option)[8].children[0].children[0].data != 0
                              }, null, 8, ["value", "disabled"]),
                              _createTextVNode("mm ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("向患者左侧移动 "),
                              _createVNode(_component_a_input, {
                                style: {"width":"80px"},
                                value: _unref(option)[8].children[0].children[0].children[1].comment,
                                "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_unref(option)[8].children[0].children[0].children[1].comment) = $event)),
                                disabled: _unref(data).disabled || _unref(option)[8].children[0].children[0].data != 1
                              }, null, 8, ["value", "disabled"]),
                              _createTextVNode("mm ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ]),
                    _createVNode(_component_a_checkbox, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("下颌")
                      ]),
                      _: 1
                    }),
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_radio_group, {
                        value: _unref(option)[8].children[0].children[1].data,
                        "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_unref(option)[8].children[0].children[1].data) = $event)),
                        disabled: _unref(data).disabled || !_unref(option)[8].children[0].data.includes(2),
                        onChange: _cache[40] || (_cache[40] = (value) => _unref(onCode2Change)(8, value, 3))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("向患者右侧移动 "),
                              _createVNode(_component_a_input, {
                                style: {"width":"80px"},
                                disabled: _unref(data).disabled || _unref(option)[8].children[0].children[1].data != 0,
                                value: _unref(option)[8].children[0].children[1].children[0].comment,
                                "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_unref(option)[8].children[0].children[1].children[0].comment) = $event))
                              }, null, 8, ["disabled", "value"]),
                              _createTextVNode("mm ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("向患者左侧移动 "),
                              _createVNode(_component_a_input, {
                                style: {"width":"80px"},
                                disabled: _unref(data).disabled || _unref(option)[8].children[0].children[1].data != 1,
                                value: _unref(option)[8].children[0].children[1].children[1].comment,
                                "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_unref(option)[8].children[0].children[1].children[1].comment) = $event))
                              }, null, 8, ["disabled", "value"]),
                              _createTextVNode("mm ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ]),
                    _createVNode(_component_a_checkbox, { value: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("其他（需要配合支抗钉纠正）")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "10、后牙反合（如果存在）" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[9].data,
                  "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_unref(option)[9].data) = $event)),
                  onChange: _cache[43] || (_cache[43] = (value) => _unref(onCode2Change)(9, value)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("不纠正")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("纠正")
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"]),
                _hoisted_26,
                _createVNode(_component_a_radio, {
                  class: "pl20",
                  checked: _unref(option)[9].children,
                  "onUpdate:checked": _cache[44] || (_cache[44] = ($event: any) => ((_unref(option)[9].children) = $event)),
                  disabled: _unref(option)[9].data != 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("需要配合牵引")
                  ]),
                  _: 1
                }, 8, ["checked", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "11、间隙与拥挤（牙弓不调）" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_a_radio_group, {
                    value: _unref(option)[10].data,
                    "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_unref(option)[10].data) = $event)),
                    disabled: _unref(data).disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("关闭间隙")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("预留间隙 "),
                          _createVNode(_component_a_input, {
                            style: {"width":"80px"},
                            disabled: _unref(data).disabled || _unref(option)[10].data != 1,
                            value: _unref(option)[10].comment,
                            "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_unref(option)[10].comment) = $event))
                          }, null, 8, ["disabled", "value"]),
                          _createTextVNode(" mm ")
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"]),
                  _hoisted_29
                ]),
                _createElementVNode("div", null, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[0].children[0].data,
                              "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((_unref(option)[10].children[0].children[0].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[0].children[1].data,
                              "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_unref(option)[10].children[0].children[1].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[0].children[2].data,
                              "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((_unref(option)[10].children[0].children[2].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_35
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[0].children[3].data,
                              "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_unref(option)[10].children[0].children[3].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[0].children[4].data,
                              "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((_unref(option)[10].children[0].children[4].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[1].children[0].data,
                              "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((_unref(option)[10].children[1].children[0].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[1].children[1].data,
                              "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((_unref(option)[10].children[1].children[1].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_41
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[1].children[2].data,
                              "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_unref(option)[10].children[1].children[2].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_42
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[1].children[3].data,
                              "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((_unref(option)[10].children[1].children[3].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(option)[10].children[1].children[4].data,
                              "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((_unref(option)[10].children[1].children[4].data) = $event)),
                              disabled: _unref(data).disabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { size: 100 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("默认")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("根据需要")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("无需")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_44,
                  _createVNode(_component_a_radio_group, {
                    value: _unref(option)[10].children[2].data,
                    "onUpdate:value": _cache[58] || (_cache[58] = ($event: any) => ((_unref(option)[10].children[2].data) = $event)),
                    onChange: _cache[59] || (_cache[59] = (value) => _unref(onCode2Change)(10, value)),
                    disabled: _unref(data).disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("不拔牙")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createVNode(_component_a_radio, {
                        style: _normalizeStyle(_unref(radioStyle)),
                        value: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("以下牙齿可以拔除 ")
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createElementVNode("div", null, [
                        _createVNode(tooth, {
                          onOnChange: _cache[57] || (_cache[57] = (checked) => _unref(onChange)(checked, 10)),
                          disabled: _unref(data).disabled || _unref(option)[10].children[2].data != 1,
                          tooth: _unref(option)[10].children[2].children
                        }, null, 8, ["disabled", "tooth"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"]),
                  _hoisted_45,
                  _hoisted_46
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "12、病例过矫治" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[11].data,
                  "onUpdate:value": _cache[61] || (_cache[61] = ($event: any) => ((_unref(option)[11].data) = $event)),
                  onChange: _cache[62] || (_cache[62] = (value) => _unref(onCode2Change)(11, value)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("否")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("是（请选择以下过矫治牙位）")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createElementVNode("div", null, [
                      _createVNode(tooth, {
                        onOnChange: _cache[60] || (_cache[60] = (checked) => _unref(onChange)(checked, 11)),
                        disabled: _unref(data).disabled || _unref(option)[11].data != 1,
                        tooth: _unref(option)[11].children
                      }, null, 8, ["disabled", "tooth"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "13、是否远程矫治" }, {
              default: _withCtx(() => [
                _hoisted_47,
                _createVNode(_component_a_radio_group, {
                  value: _unref(option)[12].data,
                  "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((_unref(option)[12].data) = $event)),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("否")
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_a_radio, {
                      style: _normalizeStyle(_unref(radioStyle)),
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("是")
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "14、特殊说明" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _unref(option)[13].data,
                  "onUpdate:value": _cache[64] || (_cache[64] = ($event: any) => ((_unref(option)[13].data) = $event)),
                  placeholder: "其他情况或设计要求请在此填写,请限制在1000字以内",
                  rows: 4,
                  disabled: _unref(data).disabled
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true)
  ]))
}
}

})